
import photo_PC from '../../Img/myPhoto/photo.png';
import photo_mobile from '../../Img/myPhoto/photo_mobile.png';



export const Photo_PC = photo_PC;
export const Photo_Mobile = photo_mobile;